import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Box,
  Button,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SoundsTableBody from "src/components/Sounds/SoundsTableBody";

const BackgroundMusicTable = ({ sounds, onDelete }) => {
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: "asc",
  });

  const handleSort = (column) => {
    const newDirection =
      sortConfig.column === column && sortConfig.direction === "asc"
        ? "desc"
        : "asc";
    setSortConfig({
      column,
      direction: newDirection,
    });
  };

  const sortedSounds = [...sounds].sort((a, b) => {
    if (!sortConfig.column) return 0;

    const aValue = a[sortConfig.column];
    const bValue = b[sortConfig.column];

    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <TableContainer>
      <Table sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                File
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("file")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("file")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ paddingLeft: "5px" }}>Preview</TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                Song
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("song")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("song")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell sx={{ paddingLeft: "5px" }}>Artist</TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                Length
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("length")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("length")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                Plays
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("plays")}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button
                    size="small"
                    sx={{ minWidth: 0, padding: 0 }}
                    onClick={() => handleSort("plays")}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell>Delete</TableCell>
          </TableRow>
        </TableHead>
        <SoundsTableBody sounds={sortedSounds} onDelete={onDelete} />
      </Table>
    </TableContainer>
  );
};

export default BackgroundMusicTable;
